import { bool } from 'prop-types';
import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';

import { iconApps, iconClock } from '../../assets';
import { C, readingTime } from '../../common';
import { Logo } from '../../components';
import { Consumer } from '../../context';
import { ENV, LAYOUT, THEME } from '../../reactor/common';
import {
  Icon, Motion, Share, Text, Touchable,
} from '../../reactor/components';
import styles from './Header.style';

const {
  PAGE_HEADER_HEIGHT,
  AMPLITUDE: {
    CLICK_TYPE, ON_CHANGE_STORY, ON_CLICK, ON_SHARE,
  },
} = C;
const { IS_WEB } = ENV;
const { COLOR, MOTION: { DURATION } } = THEME;
const TOP = LAYOUT.VIEWPORT.IPHONEX ? 28 : 0;

class Header extends PureComponent {
  _onBack = ({ logEvent, onBack, onClose }) => {
    logEvent(ON_CLICK, { type: CLICK_TYPE.ON_NAVIGATION_BACK });
    onClose(ON_CHANGE_STORY);
    onBack();
  }

  _onStories = ({ logEvent, onClose, onStories }) => {
    logEvent(ON_CLICK, { type: CLICK_TYPE.STORIES_OPEN });
    onClose(ON_CHANGE_STORY);
    onStories();
  }

  render() {
    const { _onBack, _onStories, props: { scrolling, visible } } = this;

    return (
      <Consumer>
        { ({
          dataSource: {
            logo, pages, primary, related = [], url,
          } = {}, l10n, logEvent, onBack, ...context
        }) => (
          <Motion
            delay={visible ? DURATION * 2 : 0}
            style={StyleSheet.flatten([styles.container, scrolling && styles.scroll])}
            timeline={[{ property: 'top', value: visible ? TOP : -(PAGE_HEADER_HEIGHT + TOP) }]}
          >
            { related.length > 0 && (
              <Touchable onPress={() => _onStories({ logEvent, ...context })} style={styles.touchable}>
                <Icon value={iconApps} style={styles.iconStories} />
              </Touchable>)}

            { onBack && (
              <Touchable onPress={() => _onBack({ logEvent, onBack, ...context })} style={styles.touchable}>
                <Icon value="left" style={styles.iconStories} />
              </Touchable>)}
            <Logo source={logo} />

            <Motion
              delay={scrolling ? 0 : DURATION}
              preset="fadeleft"
              style={styles.containerReading}
              visible={!scrolling}
            >
              <Icon value={iconClock} />
              <Text level={2} style={styles.labelReading}>
                {`${l10n.READING_TIME_PRE}${readingTime({ pages }).minutes}${l10n.READING_TIME_POST}`}
              </Text>
            </Motion>

            <Motion
              preset="fadeleft"
              style={styles.containerShare}
              visible={scrolling}
              delay={scrolling ? DURATION : 0}
              pointerEvents={IS_WEB ? 'none' : 'auto'}
            >
              <Share
                caption={l10n.SHARE_CAPTION}
                contained={false}
                color={COLOR.WHITE}
                onPress={() => logEvent(ON_SHARE)}
                optionColor={primary}
                rounded
                small
                style={styles.buttonShare}
                title={l10n.SHARE}
                uri={url}
              />
            </Motion>
          </Motion>
        )}
      </Consumer>
    );
  }
}

Header.propTypes = {
  scrolling: bool,
  visible: bool,
};

Header.defaultProps = {
  scrolling: false,
  visible: false,
};

export default Header;
